import axios from '@axios'

export default {
  getStatusRecoveryList(page, field) {
    return axios.post(`platform/statuses_recovery/list?page=${page}`, field)
  },
}
